import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ClipProvider } from '../features/clips/contexts/clip/clip.context';
import { ClipViewPageProvider } from '../pages/clip-view/page';
import { extractShareCode } from '../features/recap/utils/extractShareCode';
import { validate as uuidValidate } from 'uuid';

export const ClipIdResolver: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { search } = useLocation();

  const shareCode: string | null = useMemo(() => extractShareCode(search), [search]);

  if (!id) {
    navigate('/');
    return <></>;
  }

  if (shareCode) {
    if (uuidValidate(shareCode)) {
      window.location.href = `/share/${shareCode}`;
      return <></>;
    }
  }

  return (
    <ClipProvider id={id} secret={shareCode || ''}>
      <ClipViewPageProvider />
    </ClipProvider>
  );
};
